import styled from 'styled-components';
import React from 'react';
import { colors } from '../../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../../constants/text';

const CarrierName = styled.div.withConfig({ componentId: 'sc-1l9nrm0-0' })`
  color: ${colors.darkText};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.bold};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CarrierLogo = styled.img.withConfig({ componentId: 'sc-1l9nrm0-1' })`
  width: 40%;
  box-sizing: border-box;
  object-fit: contain;
  height: 40px;
  max-height: 40px;
`;

type Props = {
  className?: string;
  insuranceCarrierName?: string;
  logo?: string;
};

const Carrier = (props: Props) => {
  const { className, logo, insuranceCarrierName } = props;
  return logo ? (
    <CarrierLogo className={className} src={logo} />
  ) : (
    <CarrierName className={className}>{insuranceCarrierName}</CarrierName>
  );
};

export default Carrier;
